import { render, staticRenderFns } from "./checklist.vue?vue&type=template&id=4f3f6dde&scoped=true&"
import script from "./checklist.vue?vue&type=script&lang=ts&"
export * from "./checklist.vue?vue&type=script&lang=ts&"
import style0 from "./checklist.vue?vue&type=style&index=0&id=4f3f6dde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3f6dde",
  null
  
)

export default component.exports